import React, { FC } from "react";

import { Radio } from "antd";
import { useIntl } from "react-intl";

import PinLegendDatingMethod from "@mapmycustomers/shared/enum/pinLegends/PinLegendDatingMethod";

import RadioGroup from "@app/component/input/RadioGroup";

import ValueEditorProps from "../types/ValueEditorProps";
import getPinLegendDatingMethodDisplayName from "../utils/getPinLegendDatingMethodDisplayName";

export interface DatingMethodFieldProps extends ValueEditorProps<PinLegendDatingMethod> {}

const DatingMethodField: FC<DatingMethodFieldProps> = ({ onChange, value }) => {
  const intl = useIntl();
  return (
    <RadioGroup<PinLegendDatingMethod> onChange={onChange} value={value}>
      {(Object.values(PinLegendDatingMethod) as PinLegendDatingMethod[]).map((dataLevel) => (
        <Radio.Button key={dataLevel} value={dataLevel}>
          {getPinLegendDatingMethodDisplayName(intl, dataLevel)}
        </Radio.Button>
      ))}
    </RadioGroup>
  );
};

export default DatingMethodField;
